import React, { useEffect, useState } from "react";
import { Typography, Spin } from "antd";
import { SolutionOutlined, ClockCircleOutlined, CheckCircleOutlined, SyncOutlined, CloseCircleOutlined } from "@ant-design/icons";
import './styleTicket.css'
import axiosInstance from "../../utils/axiosInstance";
const { Title, Text } = Typography;


const TicketSummary = () => {
  const [tickets, setTickets] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    try {
      const response = await axiosInstance.get(`/tickets/status-count/`)
      setTickets(response.data);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    } finally {
      setLoading(false);
    }
  };

  // Gradient color mapping
  const gradientColors = ["from-blue-500 to-blue-700",
    "from-orange-500 to-orange-700",
    "from-yellow-500 to-yellow-700",
    "from-green-500 to-green-700", 
    "from-red-500 to-red-700",]

  useEffect(() => {
    getData();
  }, []);

  return (
    loading ? (
      <div className="flex justify-center items-center h-40">
        <Spin size="large" />
      </div>
    ) : (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 w-full px-4">
        {[
          { title: "All Tickets", value: tickets?.all_ticket || 0, color: "text-blue-600", icon: <SolutionOutlined /> },
          { title: "Open Tickets", value: tickets?.open || 0, color: "text-orange-600", icon: <ClockCircleOutlined /> },
          { title: "In Progress Tickets", value: tickets?.work_in_progress || 0, color: "text-yellow-600", icon: <SyncOutlined /> },
          { title: "Solved Tickets", value: tickets?.resolved || 0, color: "text-green-600", icon: <CheckCircleOutlined /> },
          { title: "Cancelled Tickets", value: tickets?.canceled || 0, color: "text-red-600", icon: <CloseCircleOutlined /> }
        ].map((item, index) => (
          <div key={index} className="w-full">
            <div
              className={`transition-all hover:scale-105 duration-300 dark:text-gray-200   shadow-lg rounded-3xl p-6 bg-white dark:bg-gray-500 shadow-md group h-full flex flex-col justify-between`}
            >
              {/* Header */}
              <div className="flex justify-between items-center mb-4">
                <Title level={5} className="text-gray-800 dark:text-gray-300 !font-semibold">
                  {item.title}
                </Title>
                <div className={`text-3xl ${item.color}`}>
                  {item.icon}
                </div>
              </div>

              {/* Centered Value */}
              <div className="flex items-center justify-center mb-4">
                <Text className={`text-4xl font-bold ${item.color}`}>
                  {item.value}
                </Text>
              </div>

              <div className="h-1 w-full bg-gray-200 rounded-full overflow-hidden">
                <div className={`h-full w-0 bg-gradient-to-r ${gradientColors[index]} group-hover:w-full transition-all duration-500`}>hhhhhhh</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default TicketSummary;
